export const ipcTableOfClusterDetail = {
    multiSort: '*You can sort multiple columns by clicking each header while pressing Shift key.',
    searchAll: 'Search all',
    userInputPlaceholder: 'Please enter a keyword',
    column1: 'IPC Code',
    column2: 'IPC Subclass',
    column3: 'IPC Main Group',
    column4: 'IPC Subgroup',
    column5: 'Factor Load Quantity',
    column6: 'Number of Patent Applications',

    csvColumn1: 'IPC Code',
    csvColumn2: 'IPC Subclass',
    csvColumn3: 'IPC Main Group',
    csvColumn4: 'IPC Subgroup',
    csvColumn5: 'Factor Load Quantity',
    csvColumn6: 'Number of Patent Applications'
}
